"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.form.hero.title': 'Únete a IntHub',
    'register.form.hero.description': 'Por favor usa este formulario para registrarte.',
    'register.form.hero.login_link_text': 'Si ya eres miembro, por favor',
    'register.form.hero.login_link': 'inicia sesión aquí.',
};
